import React, { useState, useEffect, useRef } from "react";
import Dropdown, { DropdownOption } from "../../../components/template/Drowpdown/dropdown";
import TopBar from "../../../components/template/TopBar/TopBar";
import ASSET_PATHS from "../../../assets/config/assetPaths";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchInspectionTemplates } from "../../../redux/slices/inspectionTemplatesSlice";
import { createAsset } from "../../../redux/slices/workOrderDetailSlice";
import { BrowserMultiFormatReader } from "@zxing/library";
import { useParams, useNavigate } from "react-router-dom";
import { ImSpinner2 } from "react-icons/im";
import PullToRefresh from "react-simple-pull-to-refresh";
import { showToaster } from "../../../redux/slices/toasterSlice";
import {
  MAX_LIMIT_128,
  MAX_LIMIT_64,
  MAX_LIMIT_EDIT_ICON_VERIFY_ID_TWO_THREE,
} from "../../../lib/inspectionItems";
import { isOfflineMode } from "../../../shared/offlineManager";

const assetTypeOptions = [
  { value: "1", label: "Year / Make / Model" },
  { value: "2", label: "Description" },
];

// const decodeVinURL = "https://vpic.nhtsa.dot.gov";
const decodeVinURL = import.meta.env.VITE_API_URL;

const initialFormState = {
  assetType: "",
  productFamily: "",
  category: "",
  vin: "",
  stockNumber: "",
  assetNumber: "",
  make: "",
  model: "",
  year: "",
  quantity: "",
  length: "",
  unit: "",
  description: "",
  creationKey: new Date().getTime().toString(),
};

const AddAsset: React.FC = () => {
  const { id } = useParams();
  const workorder_id = id ? parseInt(id) : 0;
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [scanning, setScanning] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const creationKeyRef = useRef<string>(new Date().getTime().toString());
  const [formData, setFormData] = useState({
    ...initialFormState,
    creationKey: creationKeyRef.current,
  });
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [productOptions, setProductOptions] = useState([
    { value: "0", label: "UNKNOWN" },
  ]);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [categoryOptions, setCategoryOptions] = useState([
    { value: "0", label: "UNKNOWN" },
  ]);
  const videoRef = useRef<HTMLVideoElement>(null);
  const codeReaderRef = useRef<BrowserMultiFormatReader | null>(null);

  const validateField = (name: string, value: string): string => {
    switch (name) {
      case "assetType":
        if (!value) {
          return "Please select an asset type";
        }
        break;
      case "category":
        if (!value) {
          return "Please select a Category";
        }
        break;
      case "productFamily":
        if (!value) {
          return "Please select a product family";
        }
        break;
      // case 'vin':
      //     if (formData.assetType === '1' && !value) {
      //         return 'Vin is required for type Year / Make / Model';
      //     }
      //     break;
      case "year":
        if (formData.assetType === "1" && !value) {
          return "Please select an year";
        }
        break;
      case "make":
        if (formData.assetType === "1" && !value) {
          return "Please enter a make";
        }
        if (value && value.length > MAX_LIMIT_EDIT_ICON_VERIFY_ID_TWO_THREE) {
          return "Make cannot be greater than 50 characters";
        }
        break;
      case "model":
        if (formData.assetType === "1" && !value) {
          return "Please enter a model";
        }
        if (value && value.length > MAX_LIMIT_EDIT_ICON_VERIFY_ID_TWO_THREE) {
          return "Model cannot be greater than 50 characters";
        }
        break;
      case "description":
        if (formData.assetType !== "1" && !value) {
          return "Please enter a description";
        }
        if (value && value.length > MAX_LIMIT_128) {
          return "Description cannot be greater than 128 characters";
        }
        break;
      case "quantity":
        if (formData.assetType === "3" && !value) {
          return "Please enter a quanity";
        }
        break;
      case "length":
        if (formData.assetType === "3" && !value) {
          return "Please a length";
        }
        break;
      case "unit":
        if (formData.assetType === "3" && !value) {
          return "Please select a unit";
        }
        break;
      case "stockNumber":
        if (value && value.length > MAX_LIMIT_64) {
          return "Stock Number cannot be greater than 64 characters";
        }
        break;
      case "assetNumber":
        if (value && value.length > MAX_LIMIT_EDIT_ICON_VERIFY_ID_TWO_THREE) {
          return "Asset Number cannot be greater than 50 characters";
        }
        break;
      default:
        return "";
    }
    return "";
  };

  //   const isIos14OrLater = () => {
  //     const userAgent = window.navigator.userAgent.toLowerCase();
  //     const isIOS = /iphone|ipad|ipod/.test(userAgent);
  //     const iOSVersionMatch = userAgent.match(/os (\d+)_/); // Find the iOS version
  //     const iOSVersion = iOSVersionMatch ? parseInt(iOSVersionMatch[1], 10) : 0;
  //     return isIOS && iOSVersion >= 14;
  //   };
  //   const isAndroid = (): boolean => {
  //     const userAgent = window.navigator.userAgent.toLowerCase();
  //     return /android/.test(userAgent);
  //   };

  let yearsOptions = [{ value: "0", label: "UNKNOWN" }];

  const endYear = new Date().getFullYear();
  for (let year = endYear; year >= 1940; year--) {
    yearsOptions.push({ value: String(year), label: String(year) });
  }

  const { inspectionTemplates } = useSelector(
    (state: RootState) => state.inspectionTemplates
  );

  const token = useSelector((state: RootState) => state.auth.token);

  const getInspectionTemplates = () => {
    if (token) return dispatch(fetchInspectionTemplates({ token }));
  };

  useEffect(() => {
    // Generate a new creationKey when the component mounts
    creationKeyRef.current = new Date().getTime().toString();
    setFormData((prevState) => ({
      ...prevState,
      creationKey: creationKeyRef.current,
    }));
    // Cleanup function to clear the creationKey when the component unmounts
    return () => {
      creationKeyRef.current = new Date().getTime().toString();
    };
  }, []);

  useEffect(() => {
    const map = new Map<number, string>();
    inspectionTemplates.forEach((template) => {
      if (template.categoryID && template.categoryDescription) {
        map.set(template.categoryID, template.categoryDescription);
      }
    });
  
    let categories = Array.from(map.entries()).map(([id, label]) => ({
      value: String(id),
      label,
    }));

    categories = categories.sort((a, b) =>
      a.label.localeCompare(b.label)
    );
    setCategoryOptions(categories);
  }, [inspectionTemplates]);
  
  useEffect(() => {
    let families = inspectionTemplates.filter(
      (i) =>
        i.tenant_ID === 101 &&
        i.description !== null &&
        i.description.length > 0 &&
        i.categoryID === Number(selectedCategory)
    );

    families = families.sort((a, b) =>
      a.description.localeCompare(b.description)
    );

    let list: { value: string; label: string }[] = [];

    families.forEach((i) => {
      list.push({
        value: String(i.id),
        label: i.description,
      });
    });
    setProductOptions(list);
  }, [selectedCategory]);

  const handleScannerOpen = async () => {
    try {
      setScanning(true);

      // Check if we have permission
      const permissionStatus = await navigator.permissions.query({
        name: "camera" as PermissionName,
      });

      if (permissionStatus.state === "denied") {
        // If permission was denied, show a message and return
        // dispatch(
        //   showToaster({
        //     message:
        //       "Camera permission denied. Please enable camera access in your browser settings.",
        //     type: "error",
        //   })
        // );
        // setScanning(false);
        // return;
        await navigator.mediaDevices.getUserMedia();
      }

      // Start the camera stream
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment",
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      });

      if (!videoRef.current) {
        throw new Error("Video element not found");
      }

      videoRef.current.srcObject = stream;
      await videoRef.current.play();

      // Initialize the code reader if not already done
      if (!codeReaderRef.current) {
        codeReaderRef.current = new BrowserMultiFormatReader();
      }

      // Start scanning
      codeReaderRef.current.decodeFromConstraints(
        {
          video: {
            facingMode: "environment",
            width: { ideal: 1280 },
            height: { ideal: 720 },
          },
        },
        videoRef.current,
        (result, error) => {
          if (result) {
            const text = result.getText();
            handleBarcodeRead(text);
          }
          if (error && error.name !== "NotFoundException") {
            console.error("Scanning error:", error);
          }
        }
      );
    } catch (error) {
      console.error("Error starting scanner:", error);
      setScanning(false);
      if (error instanceof Error) {
        if (error.name === "NotAllowedError") {
          dispatch(
            showToaster({
              message:
                "Camera access denied. Please enable camera access in your browser settings Or Pull down to refresh.",
              type: "error",
            })
          );
        } else {
          setScanning(false);
          dispatch(showToaster({ message: error.message, type: "error" }));
        }
      }
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: ["year", "make", "model"].includes(name)
        ? value.toUpperCase()
        : value,
    }));

    // Validate the field and update form errors
    const error = validateField(name, value);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleVinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      vin: value.toUpperCase(),
    }));
    if (value.length === 17) {
      decodeVin(value);
    }
  };

  const handleSelectProductFamily = (option: DropdownOption) => {
    setFormData((prevData) => ({
      ...prevData,
      productFamily: option.value,
    }));
  };

  const handleSelectAssetType = (option: DropdownOption) => {
    setFormData((prevData) => ({
      ...prevData,
      assetType: option.value,
    }));
  };

  const handleSelectYear = (option: DropdownOption) => {
    setFormData((prevData) => ({
      ...prevData,
      year: option.value,
    }));
  };

  // const handleSelectUnit = (value: string) => {
  //     setFormData((prevData) => ({
  //         ...prevData,
  //         unit: value,
  //     }));
  // };

  const handleCreateAsset = () => {
    const errors: { [key: string]: string } = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key as keyof typeof formData]);
      if (error) {
        errors[key] = error;
      }
    });

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const payload = {
        token,
        workorder_id,
        assetData: {
          type_ID: formData.assetType ? Number(formData.assetType) : 0,
          category_ID: Number(formData.category), // Adjust as necessary based on your form
          family_ID: Number(formData.productFamily), // Assuming productFamily is the family ID
          useYearMakeModel: formData.assetType === "1", // Only if type is '1'
          description: formData.description,
          year: formData.year,
          make: formData.make,
          model: formData.model,
          unitOfMeasure_ID: Number(formData.unit), // Assuming unit is directly usable
          length: formData.length,
          quantity: formData.quantity,
          assetNumber: formData.assetNumber,
          serialNumber: formData.vin, // Assuming vin is the serial number
          stockNumber: formData.stockNumber,
          template: inspectionTemplates.filter(
            (i) => i.id == Number(formData.productFamily)
          ),
          creationKey: creationKeyRef.current,
        },
      };
      setIsLoading(true);
      dispatch(createAsset(payload))
        .unwrap()
        .then(({ createdAsset }) => {
          setIsLoading(false);
          navigate(`/order/${workorder_id}/inspection/${createdAsset.item_ID}`);
        })
        .catch(() => {
          setIsLoading(false);
          console.error("Failed to create an asset");
        });
    } else {
      console.log("Form has errors, please correct them before submitting.");
    }
  };

  const handleScannerClose = () => {
    if (codeReaderRef.current) {
      codeReaderRef.current.reset();
    }
    if (videoRef.current) {
      const stream = videoRef.current.srcObject as MediaStream;
      if (stream) {
        stream.getTracks().forEach((track) => {
          track.stop();
          stream.removeTrack(track);
        });
        videoRef.current.srcObject = null;
      }
    }
    setScanning(false);
  };

  // Add cleanup effect
  useEffect(() => {
    return () => {
      handleScannerClose();
    };
  }, []);

  const handleBarcodeRead = (data: string) => {
    setFormData((prevData) => ({
      ...prevData,
      vin: data,
    }));
    if (data.length === 17) {
      decodeVin(data);
    }
    // Ensure camera is properly closed after successful scan
    setTimeout(() => {
      handleScannerClose();
    }, 100);
  };

  //   const handleError = (error: Error) => {
  //     console.error("Barcode scanner error:", error);
  //     dispatch(showToaster({ message: "Error reading barcode", type: "error" }));
  //   };

  const decodeVin = (vin: string) => {
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${decodeVinURL}/Assets/DecodeVin/${vin}`, options)
      .then(async (response) => {
        if (response.ok) return response.json();
        else {
          const errorText = await response.text();
          throw new Error(errorText);
        }
      })
      .then((data) => {
        var year = data.year_id;
        var make = data.make;
        var model = data.model;

        if (year) {
          setFormData((prevState) => ({
            ...prevState,
            year: String(year),
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            year: "",
          }));
        }
        if (make) {
          setFormData((prevState) => ({
            ...prevState,
            make: make,
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            make: "",
          }));
        }
        if (model) {
          setFormData((prevState) => ({
            ...prevState,
            model: model,
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            model: "",
          }));
        }
      })
      .catch((error) => {
        console.error(error);
        setFormData((prevState) => ({
          ...prevState,
          year: "",
          make: "",
          model: "",
        }));
        dispatch(showToaster({ message: error.message, type: "error" }));
      });
  };

  const handleRefresh = async () => {
    if (!isOfflineMode()) {
      await getInspectionTemplates();
      // Generate a new creationKey when refreshing
      creationKeyRef.current = new Date().getTime().toString();
      setFormData({
        ...initialFormState,
        creationKey: creationKeyRef.current,
      });
      window.location.reload();
    } else {
      window.location.reload();
    }
  };

  return (
    <PullToRefresh
      onRefresh={handleRefresh}
      refreshingContent={
        <div className="flex justify-center items-center mt-4">
          <div className="w-8 h-8 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
        </div>
      }
    >
      <div className="min-h-screen flex flex-col bg-gray-100">
        <div className="flex-1">
          <TopBar title="Add Item" showBackIcon={true} />
          <div className="p-4">
            <div className="">
              <Dropdown
                options={assetTypeOptions}
                isSearchable={false}
                placeholder="Select Type"
                onSelect={handleSelectAssetType}
              />
            </div>
            {formErrors.assetType && (
              <p className="text-red-500 text-sm mt-1 ml-1">
                {formErrors.assetType}
              </p>
            )}
            <div className="mt-4">
              <Dropdown
                options={categoryOptions}
                isSearchable={true}
                placeholder="Select Category"
                onSelect={(option) => {
                  setSelectedCategory(option.value);
                  setFormData((prev) => ({ ...prev, productFamily: "", category: option.value }));
                }}
              />
            </div>
            {formErrors.category && (
              <p className="text-red-500 text-sm mt-1 ml-1">
                {formErrors.category}
              </p>
            )}
            {selectedCategory && selectedCategory !== "0" && (
              <div className="mt-4">
                <Dropdown
                    options={productOptions}
                    isSearchable={true}
                    placeholder="Select Product Family"
                    onSelect={(option) => handleSelectProductFamily(option)}
                    value={formData.productFamily} // Ensure the value is correctly set to the product family ID
                />
              </div>
            )}
              
            {selectedCategory &&selectedCategory !== "0" && formErrors.productFamily && (
              <p className="text-red-500 text-sm mt-1 ml-1">
                {formErrors.productFamily}
              </p>
            )}
            <div className="mt-4 relative">
              <input
                type="text"
                className="w-full p-3 border border-gray-300 rounded-md pr-10 text-sm"
                placeholder="VIN/Serial Number"
                name="vin"
                value={formData.vin}
                onChange={handleVinChange}
              />
              <img
                src={ASSET_PATHS.biUpcScan}
                alt="Open Barcode Scanner"
                className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                onClick={() => handleScannerOpen()}
              />
            </div>
            {formErrors.vin && (
              <p className="text-red-500 text-sm mt-1 ml-1">{formErrors.vin}</p>
            )}
            {scanning && (
              <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-10">
                <div className="bg-white p-4 rounded-md shadow-md relative w-full max-w-2xl">
                  <button
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                    onClick={handleScannerClose}
                  >
                    ✕
                  </button>
                  <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
                    <video
                      ref={videoRef}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  </div>
                  <button
                    className="w-full p-2 border-gray-500 border rounded mt-2 text-gray-600 hover:text-gray-800"
                    onClick={handleScannerClose}
                  >
                    Close Scanner
                  </button>
                </div>
              </div>
            )}
            {formData.assetType === "1" && (
              <>
                <div className="mt-4">
                  <Dropdown
                    options={yearsOptions}
                    isSearchable={true}
                    placeholder="Select Year"
                    onSelect={handleSelectYear}
                    value={formData.year}
                  />
                </div>
                {formErrors.year && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {formErrors.year}
                  </p>
                )}
                <div className="mt-4">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-md text-sm"
                    placeholder="Make"
                    name="make"
                    value={formData.make}
                    onChange={handleInputChange}
                  />
                </div>
                {formErrors.make && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {formErrors.make}
                  </p>
                )}
                <div className="mt-4">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-md text-sm"
                    placeholder="Model"
                    name="model"
                    value={formData.model}
                    onChange={handleInputChange}
                  />
                </div>
                {formErrors.model && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {formErrors.model}
                  </p>
                )}
              </>
            )}

            {formData.assetType === "2" && (
              <>
                <div className="mt-4 relative">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-md pr-10 text-sm"
                    placeholder="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                  />
                </div>
                {formErrors.description && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {formErrors.description}
                  </p>
                )}
              </>
            )}

            {formData.assetType === "3" && (
              <>
                <div className="mt-4 relative">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-md pr-10 text-sm"
                    placeholder="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                  />
                </div>
                {formErrors.description && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {formErrors.description}
                  </p>
                )}
                <div className="mt-4 relative">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-md pr-10 text-sm"
                    placeholder="Quanity"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleInputChange}
                  />
                </div>
                {formErrors.quantity && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {formErrors.quantity}
                  </p>
                )}
                <div className="mt-4 relative">
                  <input
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-md pr-10 text-sm"
                    placeholder="Length"
                    name="length"
                    value={formData.length}
                    onChange={handleInputChange}
                  />
                </div>
                {formErrors.quantity && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {formErrors.quantity}
                  </p>
                )}
                {/* <div className="mt-4 relative">
                                <Dropdown
                                    options={unitType}
                                    isSearchable={true}
                                    placeholder="Select Unit of Measure"
                                    onSelect={handleSelectUnit}
                                />
                            </div>
                            {formErrors.unit && <p className="text-red-500 text-sm mt-1 ml-1">{formErrors.unit}</p>} */}
              </>
            )}

            <div className="mt-4">
              <input
                type="text"
                className="w-full p-3 border border-gray-300 rounded-md text-sm"
                placeholder="Stock Number"
                name="stockNumber"
                value={formData.stockNumber}
                onChange={handleInputChange}
              />
            </div>
            {formErrors.stockNumber && (
              <p className="text-red-500 text-sm mt-1 ml-1">
                {formErrors.stockNumber}
              </p>
            )}

            <div className="mt-4">
              <input
                type="text"
                className="w-full p-3 border border-gray-300 rounded-md text-sm"
                placeholder="Asset Number"
                name="assetNumber"
                value={formData.assetNumber}
                onChange={handleInputChange}
              />
            </div>
            {formErrors.assetNumber && (
              <p className="text-red-500 text-sm mt-1 ml-1">
                {formErrors.assetNumber}
              </p>
            )}
          </div>

          <div className="p-4 mt-4 mb-4">
            <button
              className="w-full bg-primary text-white rounded-md p-3 shadow-button-shadow"
              onClick={handleCreateAsset}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="py-1 flex justify-center">
                  <ImSpinner2 className="animate-spin mr-2" />
                </div>
              ) : (
                "Create"
              )}
            </button>
          </div>
        </div>
      </div>
    </PullToRefresh>
  );
};

export default AddAsset;
